import { ThunkAction, Action, createStore, combineReducers, applyMiddleware } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'
import { AlunoReducer } from './Aluno'
import { AuthReducer } from './Auth'
import { SharedReducer } from './Shared'

export const Store = createStore(
  combineReducers({
    Auth: AuthReducer,
    Aluno: AlunoReducer,
    Shared: SharedReducer,
  }),
  applyMiddleware(thunkMiddleware)
)

export type RootState = ReturnType<typeof Store.getState>
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
